import React from 'react'
import {
	Button,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Dialog
} from '@material-ui/core'

interface ConfirmDeleteModalProps {
	open: boolean
	onClose: () => void
	onConfirm: () => void
}

const SectionsDelete: React.FC<ConfirmDeleteModalProps> = ({
	open,
	onClose,
	onConfirm
}) => {
	return (
		<Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
			<DialogTitle>Confirm Delete</DialogTitle>

			<DialogContent>
				<DialogContentText>
					Are you sure you want to delete this item? This action cannot be undone.
				</DialogContentText>
			</DialogContent>

			<DialogActions>
				<Button onClick={onClose} variant="outlined">
					Cancel
				</Button>
				<Button
					onClick={onConfirm}
					variant="contained"
					sx={{
						backgroundColor: '#B22222',
						'&:hover': {
							backgroundColor: '#cc3d3d'
						}
					}}
				>
					Ok
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default SectionsDelete
